export default "__VITE_ASSET__CtZlT7_L__"